import { Button, ButtonProps } from '@billy/design-system'
import React from 'react'

export const Submit = ({ children, ...rest }: ButtonProps) => (
  <Button variant="filled" type="submit" {...rest}>
    {children}
  </Button>
)
